<ng-template #content let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <div class="inline">
      <h4 class="modal-title">
        {{ 'components.reassignUser.title' | translate }}
      </h4>
      @if (shouldRenderTooltip) {
        <app-tooltip [marginBottom]="false" text="components.reassignUser.title" />
      }
    </div>
    <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    <form [formGroup]="form">
      <div class="lna-row full-width">
        <div class="label-wrapper">
          <label class="lna form-label" for="newReadingRoom">
            {{ 'components.reassignUser.userId' | translate }}
            <span class="required-field">*</span>
          </label>
        </div>
        <app-search-user-input
          [invalid]="this.shouldRenderError('userId')"
          [disabledUsersOptions]="disabledUsersOptions"
          (userSelected)="onUserSelected($event)" />
        @if (getErrorMessage('userId'); as errorMessage) {
          <div class="error-wrapper">
            <small class="error-message">
              {{ errorMessage | translate }}
            </small>
          </div>
        }
      </div>
      <div class="lna-row full-width">
        <div class="label-wrapper">
          <label class="form-label lna" for="name">
            {{ 'components.reassignUser.reasonForUser' | translate }}
            <span class="required-field">*</span>
          </label>
        </div>
        <div class="textarea-wrapper">
          <textarea
            class="form-control lna"
            id="reasonForUser"
            [ngClass]="{ invalid: shouldRenderError('reasonForUser') }"
            type="text"
            formControlName="reasonForUser"
            name="reasonForUser"
            required
            maxlength="{{ maxFieldLength }}"></textarea>
          <p
            class="length"
            [ngClass]="{
              invalid: reasonForUser?.value.length > maxFieldLength
            }">
            {{ reasonForUser?.value.length }}/{{ maxFieldLength }}
          </p>
        </div>
        @if (getErrorMessage('reasonForUser'); as errorMessage) {
          <div class="error-wrapper">
            <small class="error-message">
              {{ errorMessage | translate }}
            </small>
          </div>
        }
      </div>
    </form>
  </div>
  <div class="lna-modal-footer">
    <button class="primary" (click)="submit()" type="button">
      {{ 'components.reassignUser.save' | translate }}
    </button>
    <button class="secondary" (click)="close()" type="button">
      {{ 'components.reassignUser.cancel' | translate }}
    </button>
  </div>
</ng-template>
